import React from 'react'
import {Helmet} from "react-helmet"
import subjects from '~/comm'
import { connect } from 'react-redux'
import { fetchAlbumIfNeeded } from '~/reviews/actions'

class Album extends React.Component {

  constructor() {
    super();
    this.state = {
      data: []
    }
  }

  static fetchData(store, route, match) {
    return Promise.all([
      store.dispatch(fetchAlbumIfNeeded(match.params.id))
    ])
  }

  componentDidMount() {
    const { match, history, dispatch, albumid } = this.props
    dispatch(fetchAlbumIfNeeded(albumid))
  }

  componentWillReceiveProps(nextProps){
    const { albumid, dispatch } = nextProps
    if(this.props.albumid !== albumid)
      dispatch(fetchAlbumIfNeeded(albumid))
  }
  componentWillUnmount() {
  }

  render() {
    const { match, history, albums, albumid } = this.props
    const data = this.state.data;
    var album

    if ( albumid && albums.reviews[albumid] && !albums.reviews[albumid].isFetching ) {
      album = albums.reviews[albumid]
    }
    var article = []

    function bla(str) { return str.replace(/^\((.*)\)$/g, '$1') }

    if (album && album.title) {
      var result = "<p>" + album.body[0].value + "</p>";
      result = result.replace(/\r\n\r\n/g, "</p><p>").replace(/\n\n/g, "</p><p>");
      result = result.replace(/\r\n/g, "<br />").replace(/\n/g, "<br />");
      var badmarkup = { __html: result  };
      article.push(
        <div key={1} className="album-review">
          <Helmet>
            <title>{album.field_review_album_artist[0].value + ' - ' + album.field_review_album_title[0].value}</title>
            <meta name="description" content={album.body[0].value.replace(/<[^>]+>/g, '').slice(0, 140)  } />
            <meta name="og:description" content={album.body[0].value.replace(/<[^>]+>/g, '').slice(0, 140)  } />
            <meta property="og:title" content={album.field_review_album_artist[0].value + ' - ' +  album.field_review_album_title[0].value} />
            <meta property="og:image" content={ album.field_review_image[0].url } />
            <meta property="og:type" content="article" />
          </Helmet>

          <div className="review-art">
            <img src={album.field_review_image[0].url } />
          </div>
          <div className="review-text">
            <span className="album-artist">
              {album.field_review_album_artist[0].value}
            </span>
            <span className="album-title">
              {album.field_review_album_title[0].value}
            </span>
            {album.field_review_album_label.length > 0 &&
            <div className="album-label">
              {bla(album.field_review_album_label[0].value)}
            </div>
            }
            <div className="review">
              <div dangerouslySetInnerHTML={badmarkup} />
            </div>
          </div>
        </div>
      )
    } else {
      //article.push(match.params.id)
    }

    if (!article) {
      return null
    }

    return (
      <div id="album-review">
        {article}
      </div>
    )
  }
}

export default connect(state => { return { albums: state.albums } }) (Album)
